export default __webpack_public_path__ + "static/media/MZKZ-UKE.9edb67c7.jpg";